import { createAction, props } from '@ngrx/store';
import { ISignInRes } from '../../shared/models/auth.model';

export const signIn = createAction('[Auth] Sign In', props<{ response: ISignInRes }>());
export const signInSuccess = createAction('[Auth] Sign In Success', props<{ response: ISignInRes }>());
export const signInFailure = createAction('[Auth] Sign In Failure', props<{ error: any }>());
export const logout = createAction('[Auth] Logout');
